/**
 * 打开新tab页
 * @param url {string}
 */
export function openNewTab (url) {
  const a = document.createElement('a')
  a.href = url
  a.target = Math.random()

  document.body.append(a)
  a.click()
  a.remove()
}



// WEBPACK FOOTER //
// ./src/utils/index.js